export default __webpack_public_path__ + "static/media/squares800.a707ff47.jpg";